module.exports = __webpack_public_path__ + "static/media/proecuador.b032f6fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/partnership/proecuador.png
// module id = 147
// module chunks = 0